export const STATE_FETCH = 'STATE_FETCH'
export const STATE_CREATE = 'STATE_CREATE'
export const STATE_UPDATE = 'STATE_UPDATE'
